(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification-popup"]) return;
  try {
    
  const button = document.getElementById('age-validator-fail');
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const errorContainer = document.getElementById('age-error-container');
    errorContainer.classList.remove('hidden');
  });
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalComponentAgePopup extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.initPopupBehavior();
    }
    initPopupBehavior() {
      const storageKey = this.dataset.storageKey;
      const storageValue = this.dataset.storageValue || null;
      if (storageKey && localStorage.getItem(storageKey) === storageValue) {
        this.remove();
        return;
      }
      if (!window.location.href.includes('challenge') || !this.classList.contains('modal--active')) {
        if (this.dataset.trigger === 'self') {
          this.open();
          return;
        }
        this.onScroll = this.showOnScroll.bind(this);
        this.delay = parseInt(this.dataset.delay || "0", 10);
        window.addEventListener('scroll', this.onScroll);
      }
    }
    showOnScroll() {
      if (window.scrollY > this.delay) {
        window.removeEventListener('scroll', this.onScroll);
        this.open();
      }
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
  }
  if(!customElements.get('modal-component-age-popup')) customElements.define('modal-component-age-popup', ModalComponentAgePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) return this.hideTimer();
      const els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const last = { days: null, hours: null, minutes: null, seconds: null };
      const frames = this.dataset.frames ? JSON.parse(this.dataset.frames) : null;
      const options = this.dataset.options ? JSON.parse(this.dataset.options) : null;
      const doAnimate = (el) => {
        if (!el || !frames || !options) return;
        el.animate(frames, options);
      };
      const hideTimer = () => {
        this.classList.add('hidden');
        if (this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
        const message = this.nextElementSibling;
        if (message?.hasAttribute('data-message')) message.classList.remove('hidden');
      };
      const update = () => {
        const remaining = endDate.getTime() - Date.now();
        if (remaining <= 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          Object.values(els).forEach(el => el && (el.textContent = '0'));
          hideTimer();
          this.dispatchEvent(new Event('timeup'));
          return;
        }
        const current = {
          days: Math.floor(remaining / 864e5),
          hours: Math.floor((remaining % 864e5) / 36e5),
          minutes: Math.floor((remaining % 36e5) / 6e4),
          seconds: Math.floor((remaining % 6e4) / 1e3)
        };
        for (const unit in current) {
          if (els[unit] && last[unit] !== current[unit]) {
            els[unit].textContent = current[unit];
            if (last[unit] !== null) doAnimate(els[unit]);
            last[unit] = current[unit];
          }
        }
      };
      update();
      this.intervalId = setInterval(update, 1000);
    }
    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }

    onClickRef() {
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        if (this.dataset.offset) {
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if (!offsetElement) {
            doScroll();
            if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }

      function doScroll() {
        targetElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-content"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this.targetValue = parseFloat(this.dataset.afterPlacement || this.style.getPropertyValue('--after-placement')) || 50;
      this.currentValue = 0;
      this.isAnimating = false;
    }

    connectedCallback() {
      this.pointer = this.querySelector('input');
      if (!this.pointer) return;

      const onComparison = (event) => {
        this.style.setProperty('--after-placement', `${event.target.value}%`);
      };

      const setListeners = () => {
        this.comparison = onComparison.bind(this);
        this.pointer.addEventListener('input', this.comparison);
      };

      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const animateValue = () => {
        const duration = 1000; // in ms
        const start = performance.now();
        const startValue = 0;
        const endValue = this.targetValue;

        const frame = (timestamp) => {
          const elapsed = timestamp - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeOutCubic(progress);
          this.currentValue = startValue + (endValue - startValue) * eased;

          this.style.setProperty('--after-placement', `${this.currentValue}%`);

          if (progress < 1) {
            requestAnimationFrame(frame);
          } else {
            this.isAnimating = false;
          }
        };

        requestAnimationFrame(frame);
      };

      const handleIntersection = (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimating && window.innerWidth > 767) {
            this.isAnimating = true;
            this.currentValue = 0;
            this.style.setProperty('--after-placement', '0%');
            animateValue();
            this._observer.unobserve(this);
          }
        });
      };

      if (this.hasAttribute('data-animate')) {
        this._observer = new IntersectionObserver(handleIntersection, {
          threshold: 0.1
        });
        this._observer.observe(this);
      }

      setListeners();
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }
  }
  if (!customElements.get('before-after')) customElements.define('before-after', BeforeAfter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["example"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) return this.hideTimer();
      const els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const last = { days: null, hours: null, minutes: null, seconds: null };
      const frames = this.dataset.frames ? JSON.parse(this.dataset.frames) : null;
      const options = this.dataset.options ? JSON.parse(this.dataset.options) : null;
      const doAnimate = (el) => {
        if (!el || !frames || !options) return;
        el.animate(frames, options);
      };
      const hideTimer = () => {
        this.classList.add('hidden');
        if (this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
        const message = this.nextElementSibling;
        if (message?.hasAttribute('data-message')) message.classList.remove('hidden');
      };
      const update = () => {
        const remaining = endDate.getTime() - Date.now();
        if (remaining <= 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          Object.values(els).forEach(el => el && (el.textContent = '0'));
          hideTimer();
          this.dispatchEvent(new Event('timeup'));
          return;
        }
        const current = {
          days: Math.floor(remaining / 864e5),
          hours: Math.floor((remaining % 864e5) / 36e5),
          minutes: Math.floor((remaining % 36e5) / 6e4),
          seconds: Math.floor((remaining % 6e4) / 1e3)
        };
        for (const unit in current) {
          if (els[unit] && last[unit] !== current[unit]) {
            els[unit].textContent = current[unit];
            if (last[unit] !== null) doAnimate(els[unit]);
            last[unit] = current[unit];
          }
        }
      };
      update();
      this.intervalId = setInterval(update, 1000);
    }
    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr, root = document) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      const element = root.querySelector(selector);
      if (element) arr.push(element);
    });
    return arr;
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  if (!customElements.get('atc-submit') && typeof AtcSubmit !== 'undefined') {
    customElements.define('atc-submit', AtcSubmit);
  }
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled');
            if (this.loader) this.loader.classList.remove('hidden');
            if (typeof toggleLoader === 'function') toggleLoader(true);
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled');
                  if (this.loader) this.loader.classList.add('hidden');
                }

                if (typeof toggleLoader === 'function') toggleLoader(false);
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class StickyBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.refBlock && !this.dataset.behavior) return;
      const stickyHide = () => {
        this.setAttribute('data-revealed', false);
        this.dataset.hasHidden === 'true' && this.setAttribute('aria-hidden', true);
        this.dataset.bodyClass && document.body.classList.remove(this.dataset.bodyClass);
        this.refBlock && this.dataset.classes && this.refBlock.classList.remove(...this.dataset.classes.split(' ').filter(Boolean));
        this.height && (this.style.removeProperty('height'), this.dataset.bodyClass && document.body.style.removeProperty(this.dataset.refProperty));
      };
      const setStickyStatus = (revealed) => {
        if (this.dataset.hideOnEnd === 'true' && window.innerHeight + window.scrollY >= this.endBounds) return stickyHide();
        if (!revealed) return stickyHide();
        this.setAttribute('data-revealed', true);
        this.dataset.hasHidden === 'true' && this.removeAttribute('aria-hidden');
        this.dataset.bodyClass && document.body.classList.add(this.dataset.bodyClass);
        this.refBlock && this.dataset.classes && this.refBlock.classList.add(...this.dataset.classes.split(' ').filter(Boolean));
        this.height && (this.style.height = `${this.height}px`, this.dataset.bodyClass && document.body.style.setProperty(this.dataset.refProperty, `${this.height}px`));
      };
      this.onObservedScroll = () => new IntersectionObserver((entries, observer) => (observer.unobserve(this), entries.forEach(entry => setStickyStatus(!entry.isIntersecting))), { rootMargin: '0px 0px -60px 0px' }).observe(this);
      this.onDownwardScroll = () => (this.percent && (this.threshold = (document.documentElement.offsetHeight * parseFloat(this.percent)) / 100), setStickyStatus(window.scrollY > this.threshold));
      this.onUpwardScroll = () => (setStickyStatus(window.scrollY < this.previousScrollAmount && window.scrollY >= (this.height || this.refBlock.offsetHeight)), this.previousScrollAmount = window.scrollY);
      this.onStackedScroll = () => (this.refBoundings.y < 0 && (this.refBoundings.y += window.scrollY), setStickyStatus(this.refBoundings.y < window.scrollY));
      const initialize = () => {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        if (this.behavior) {
          const handlers = { downwards: this.onDownwardScroll, upwards: this.onUpwardScroll, stacked: this.onStackedScroll, observer: this.onObservedScroll };
          (this.scrollHandler = handlers[this.behavior]) ? window.addEventListener('scroll', this.scrollHandler) : console.log('init sticky block');
        }
        if (!(this.refBlock = document.querySelector(this.dataset.refBlock))) return;
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + parseFloat(this.dataset.offset || 0);
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage || null;
        this.spacer && (this.height = this.refBlock.offsetHeight);
        if (this.dataset.refHeightDefault && this.dataset.refHeightDefault !== 'true') {
          let totalHeight = 0;
          document.querySelectorAll(this.dataset.refHeightDefault).forEach(el => totalHeight += el.offsetHeight);
          this.dataset.refHeightDefaultProperty && document.body.style.setProperty(this.dataset.refHeightDefaultProperty, `${totalHeight}px`);
        }
      };
      this.setTempoStatus = (flag, ref) => document.querySelector(ref)?.style.setProperty('transform', flag ? 'translateY(0%)' : 'translateY(-100%)');
      this.setStickyStatus = setStickyStatus;
      this.initLoad = setTimeout(initialize, 100);
      this.onDOMLoad = () => this.initLoad;
      document.addEventListener('DOMContentLoaded', this.onDOMLoad);
    }
    disconnectedCallback() {
      this.scrollHandler && window.removeEventListener('scroll', this.scrollHandler);
      this.onDOMLoad && document.removeEventListener('DOMContentLoaded', this.onDOMLoad);
      clearTimeout(this.initLoad);
    }
  }
  if (!customElements.get('sticky-block')) customElements.define('sticky-block', StickyBlock);
  class CartDrawerDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-drawer-dropdown')) {
    customElements.define('cart-drawer-dropdown', CartDrawerDropdown);
  }
  class CartWidgetDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeBtn = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.closeDropdown();
        });
      }
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const getCartModalBody = () => self.closest('.modal-component_body') || null;
      const showCartOverlay = () => {
        const cartBody = getCartModalBody();
        if (!cartBody) return;
        let overlay = cartBody.querySelector('.cart-widget-overlay');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'cart-widget-overlay';
          overlay.setAttribute('aria-hidden', 'true');
          Object.assign(overlay.style, {
            position: 'absolute',
            inset: '0',
            background: 'rgba(0,0,0,0.70)',
            zIndex: '10',
            pointerEvents: 'all',
            cursor: 'default',
            opacity: '0',
            transition: 'opacity 0.25s ease',
          });
          cartBody.style.position = 'relative';
          cartBody.appendChild(overlay);
        }
        requestAnimationFrame(() => { overlay.style.opacity = '1'; });
        overlay.addEventListener('click', (e) => {
          e.stopPropagation();
          closeDropdown();
        }, { once: true });
      };
      const hideCartOverlay = () => {
        const cartBody = getCartModalBody();
        if (!cartBody) return;
        const overlay = cartBody.querySelector('.cart-widget-overlay');
        if (!overlay) return;
        overlay.style.opacity = '0';
        overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        showCartOverlay();
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        hideCartOverlay();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-widget-dropdown')) {
    customElements.define('cart-widget-dropdown', CartWidgetDropdown);
  }
  class ModalCartToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-cart-toggler'))
    customElements.define('modal-cart-toggler', ModalCartToggler);
  class ModalCartRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);

      this.applyColorScheme = (body) => {
        const { colorScheme } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      this.applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }

    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }

    close() {
      const parent = this.querySelector(this.dataset.selector);
      if (parent) parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }

    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }

    renderModal() {
      toggleLoader(true);
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          if (parent && html) parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
          toggleLoader(false);
        });
    }

    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }

    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      if (flag) {
        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('click', this.onBodyClick);
      } else {
        this.removeEventListener('keyup', this.onKeyUp);
        this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (!boundings || boundings.contains(target) || target === boundings) return;
      this.close();
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-cart-render-component'))
    customElements.define('modal-cart-render-component', ModalCartRenderComponent);
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' || event.target.parentElement.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]') || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }

    onLineItemUpdate() {
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const handleLineError = (parent, response) => {
    const parentElement = document.querySelector(parent);
    const errorContainer = parentElement.querySelector('[data-render-error]');
    errorContainer.classList.remove('hidden');
    errorContainer.innerText = response.errors;
    const qtyInput = parentElement.querySelector('input[name="updates[]"]');
    qtyInput.value = parseFloat(parentElement.dataset.initQty);
    toggleLoader(false);
    return (this.erorr = true);
  };
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  const lineItemUpdate = (line, quantity, sections, parent) => {
    toggleLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map((section) => section.id),
      sections_url: window.location.pathname,
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if (response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (!this.erorr) {
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if (modal) {
            if (modal.classList.contains('modal--active')) {
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        toggleLoader(false);
      });
  };
  if (!customElements.get('line-item-remove')) {
    customElements.define(
      'line-item-remove',
      class LineItemRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const onRemoval = (event) => {
            event.preventDefault();
            lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
          };
          this.removal = onRemoval.bind(this);
          this.button.addEventListener('click', this.removal);
        }
      }
    );
  }
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-cart-totals'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'data-cart-totals' && oldValue !== newValue) {
            this.update();
          }
        }

        connectedCallback() {
          this.update();
        }

        update() {
          const rateFactor = Shopify.currency.rate || 1;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
          const epsilon = 0.001;

          // Milestones configuration
          const milestones = [
            {
              id: 'shipping',
              threshold: parseFloat(this.dataset.amount) * rateFactor,
              successText: this.dataset.freeShippingUnlockedText || 'Free shipping unlocked!',
              label: 'Free Shipping'
            }
          ];

          if (this.hasAttribute('data-discount-amount')) {
            milestones.push({
              id: 'discount',
              threshold: parseFloat(this.dataset.discountAmount) * rateFactor,
              successText: this.dataset.discountUnlockedText || 'Discount activated!',
              label: this.dataset.discountText || 'Discount'
            });
          }

          // Sort milestones by threshold to handle any user order
          milestones.sort((a, b) => a.threshold - b.threshold);

          const achieved = milestones.filter(m => cartTotals >= m.threshold - epsilon);
          const next = milestones.find(m => cartTotals < m.threshold - epsilon);

          const textContainer = this.querySelector('.shipping-bar_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }

            let message = '';
            if (achieved.length > 0) {
              message = achieved.map(m => m.successText).join(' & ');
            }

            if (next) {
              const remaining = next.threshold - cartTotals;
              const nextMessage = next.id === 'shipping' 
                ? this.baseTextTemplate.replace(/\|\|amount\|\|/g, `<span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span>`)
                : `Add <span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span> more for <span>${next.label}</span>`;
              
              message = message ? `${message} ${nextMessage}` : nextMessage;
            }

            textContainer.innerHTML = message || window.cartStrings.shippingAmount;
          }

          // Update Progress Bar Appearance
          const maxThreshold = milestones.length > 0 ? Math.max(...milestones.map(m => m.threshold)) : 100;
          const value = Math.min((cartTotals / maxThreshold) * 100, 100);
          
          const fill = this.querySelector('.milestone-fill');
          if (fill) {
            fill.style.width = value.toFixed(2) + '%';
            if (value >= 100 - epsilon) {
              fill.classList.add('is-full');
            } else {
              fill.classList.remove('is-full');
            }
          }

          milestones.forEach(m => {
            const milestoneEl = this.querySelector(`.milestone-point--${m.id}`);
            if (milestoneEl) {
              const percent = Math.min((m.threshold / maxThreshold) * 100, 100);
              milestoneEl.style.left = percent + '%';
              if (cartTotals >= m.threshold - epsilon) {
                milestoneEl.classList.add('is-active');
              } else {
                milestoneEl.classList.remove('is-active');
              }
            }
          });
        }
      }
    );
  }
  class cartDiscountCode extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      const input = this.querySelector('input[name="discount_code"]');
      if (!button || !input) return;
      const onClick = (event) => {
        event.preventDefault();
        toggleLoader(true);
        const secArr = JSON.parse(this.dataset.sections);
        const discountCode = input.value.trim();
        var body = JSON.stringify({
          discount: discountCode,
          sections: secArr.map((section) => section.id),
          sections_url: window.location.pathname,
        });
        this.erorr = false;
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const response = JSON.parse(responseText);
            if (response.errors) return handleLineError(parent, response);
            sectionArrRender(secArr, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.erorr) {
              const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
              if (modal) {
                if (modal.classList.contains('modal--active')) {
                  trapFocus(modal.content);
                  modal.setListeners(true);
                }
              }
            }
            toggleLoader(false);
          });
      };
      this.onClick = onClick;
      button.addEventListener('click', onClick);
    }
  }
  if (!customElements.get('cart-discount-code')) customElements.define('cart-discount-code', cartDiscountCode);
  if (!customElements.get('cart-timer')) {
    customElements.define(
      'cart-timer',
      class CartTimer extends HTMLElement {
        constructor() {
          super();
          this.timerDuration = parseInt(this.dataset.duration) * 60; // in seconds
          this.storageKey = 'cart_timer_expiry';
          this.interval = null;
        }

        connectedCallback() {
          const storedExpiry = sessionStorage.getItem(this.storageKey);
          if (storedExpiry) {
            this.timerExpiry = parseInt(storedExpiry);
          } else {
            this.timerExpiry = Date.now() + this.timerDuration * 1000;
            sessionStorage.setItem(this.storageKey, this.timerExpiry.toString());
          }

          if (Date.now() >= this.timerExpiry) {
            this.onExpire();
          } else {
            this.startTimer();
          }
        }

        startTimer() {
          this.updateDisplay();
          this.interval = setInterval(() => {
            if (Date.now() >= this.timerExpiry) {
              clearInterval(this.interval);
              this.onExpire();
            } else {
              this.updateDisplay();
            }
          }, 1000);
        }

        updateDisplay() {
          const remaining = Math.max(0, Math.floor((this.timerExpiry - Date.now()) / 1000));
          const minutes = Math.floor(remaining / 60);
          const seconds = remaining % 60;
          const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
          
          const textContainer = this.querySelector('.cart-timer_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }
            textContainer.innerHTML = this.baseTextTemplate.replace(/\|\|timer\|\|/g, `<span>${timeString}</span>`);
          }
        }

        onExpire() {
          sessionStorage.removeItem(this.storageKey);
          if (typeof toggleLoader === 'function') toggleLoader(true);
          const clearUrl = window.routes?.cart_clear_url || '/cart/clear';
          fetch(clearUrl, { method: 'POST' })
            .then(() => {
              location.reload();
            })
            .catch(() => {
              location.reload();
            });
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
        }
      }
    );
  }
  if (!customElements.get('shipping-protection')) {
    customElements.define(
      'shipping-protection',
      class ShippingProtection extends HTMLElement {
        constructor() {
          super();
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.variantId = this.dataset.variantId;
          this.lineKey = this.dataset.lineKey;
          this.sections = JSON.parse(this.dataset.sections || '[]');
        }

        connectedCallback() {
          if (!this.checkbox) return;
          this.checkbox.addEventListener('change', this.onChange.bind(this));
        }

        onChange() {
          const isChecked = this.checkbox.checked;
          if (isChecked) {
            this.addProtection();
          } else {
            this.removeProtection();
          }
        }

        addProtection() {
          if (typeof toggleLoader === 'function') toggleLoader(true);
          const body = JSON.stringify({
            id: this.variantId,
            quantity: 1,
            sections: this.sections.map((s) => s.id),
            sections_url: window.location.pathname
          });

          fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.sections) {
                sectionArrRender(this.sections, response);
              } else {
                location.reload();
              }
            })
            .catch((e) => {
              console.error(e);
              location.reload();
            })
            .finally(() => {
              if (typeof toggleLoader === 'function') toggleLoader(false);
            });
        }

        removeProtection() {
          if (typeof toggleLoader === 'function') toggleLoader(true);
          const body = JSON.stringify({
            id: this.lineKey || this.variantId,
            quantity: 0,
            sections: this.sections.map((s) => s.id),
            sections_url: window.location.pathname
          });

          fetch(`${window.routes.cart_change_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.sections) {
                sectionArrRender(this.sections, response);
              } else {
                location.reload();
              }
            })
            .catch((e) => {
              console.error(e);
              location.reload();
            })
            .finally(() => {
              if (typeof toggleLoader === 'function') toggleLoader(false);
            });
        }
      }
    );
  }

  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }

    onClickRef() {
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        if (this.dataset.offset) {
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if (!offsetElement) {
            doScroll();
            if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }

      function doScroll() {
        targetElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class SequentialAnimator extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-sequential-element]'));
      if (items.length === 0) return;
      let activeIndex = -1;
      let interval = null;
      const intervalTime = 2000;
      const setActive = (index) => {
        items.forEach(item => item.classList.remove('--active'));
        activeIndex = index;
        if (items[activeIndex]) items[activeIndex].classList.add('--active');
      };
      const next = () => {
        const nextIndex = (activeIndex + 1) % items.length;
        setActive(nextIndex);
      };
      const stopAnimation = () => {
        if (interval) clearInterval(interval);
      };
      const startAnimation = () => {
        stopAnimation();
        interval = setInterval(next, intervalTime);
      };
      startAnimation();
      this._animationActive = true;
      items.forEach((item, index) => {
        item.addEventListener('mouseenter', () => {
          stopAnimation();
          setActive(index);
        });
        item.addEventListener('mouseleave', () => {
          startAnimation();
        });
      });
      this._stopAnimation = stopAnimation;
    }
    disconnectedCallback() {
      if (this._stopAnimation) {
        this._stopAnimation();
        this._animationActive = false;
      }
    }
  }
  if (!customElements.get('sequential-animator')) customElements.define('sequential-animator', SequentialAnimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  const selectors = {
    customerAddresses: '[data-customer-addresses]',
    addressCountrySelect: '[data-address-country-select]',
    addressContainer: '[data-address]',
    toggleAddressButton: 'button[data-address-button]',
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: 'button[data-confirm-message]',
  };
  const attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message',
  };
  class CustomerAddresses {
    constructor() {
      this.elements = this._getElements();
      if (Object.keys(this.elements).length === 0) return;
      this._setupCountries();
      this._setupEventListeners();
    }

    _getElements() {
      const container = document.querySelector(selectors.customerAddresses);
      return container
        ? {
            container,
            addressContainer: container.querySelector(selectors.addressContainer),
            toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
            cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
            deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
            countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
          }
        : {};
    }

    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        });
        this.elements.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
            hideElement: `AddressProvinceContainer_${formId}`,
          });
        });
      }
    }

    _setupEventListeners() {
      this.elements.toggleButtons.forEach((element) => {
        element.addEventListener('click', this._handleAddEditButtonClick);
      });
      this.elements.cancelButtons.forEach((element) => {
        element.addEventListener('click', this._handleCancelButtonClick);
      });
      this.elements.deleteButtons.forEach((element) => {
        element.addEventListener('click', this._handleDeleteButtonClick);
      });
    }

    _toggleExpanded(target) {
      target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
    }

    _handleAddEditButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);
    };

    _handleCancelButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
    };

    _handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: 'delete' },
        });
      }
    };
  }
  window.addEventListener('load', () => {
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  });
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalAddressToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-address-toggler')) customElements.define('modal-address-toggler', ModalAddressToggler);
  class ModalAddressComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-address-component')) customElements.define('modal-address-component', ModalAddressComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class TruncateText extends HTMLElement {
    constructor() {
      super();
      this.truncateLength = parseInt(this.getAttribute('truncate-length')) || 5;
      this.originalText = '';
      this.isExpanded = false;
      this.toggleButton = null;
    }

    connectedCallback() {
      const toggleButton = this.querySelector('.toggle-text');
      if (!toggleButton) return;

      this.toggleButton = toggleButton;
      toggleButton.remove();

      this.originalText = this.innerHTML.trim();
      this.appendChild(toggleButton);

      toggleButton.addEventListener('click', this.toggleTruncate.bind(this));
      this.truncateContent();
    }

    truncateContent() {
      const words = this.originalText.trim().split(/\s+/);
      if (words.length <= this.truncateLength) {
        this.toggleButton.style.display = 'none';
        return;
      }

      this.innerHTML = '';

      // Use Shopify translation text stored in data attributes
      const readMoreText = this.dataset.readMoreText || window.read_more_text || 'Read more';
      const readLessText = this.dataset.readLessText || window.read_less_text || 'Read less';

      if (!this.isExpanded) {
        const truncatedText = words.slice(0, this.truncateLength).join(' ') + '... ';
        this.appendChild(document.createTextNode(truncatedText));
        this.toggleButton.textContent = readMoreText;
      } else {
        this.appendChild(document.createTextNode(this.originalText));
        this.toggleButton.textContent = readLessText;
      }

      this.appendChild(this.toggleButton);
    }

    toggleTruncate(event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
      this.truncateContent();
    }
  }
  if (!customElements.get('truncate-text')) {
    customElements.define('truncate-text', TruncateText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class CartDrawerDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-drawer-dropdown')) {
    customElements.define('cart-drawer-dropdown', CartDrawerDropdown);
  }
  class CartWidgetDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeBtn = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.closeDropdown();
        });
      }
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-widget-dropdown')) {
    customElements.define('cart-widget-dropdown', CartWidgetDropdown);
  }
  class ModalCartToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-cart-toggler'))
    customElements.define('modal-cart-toggler', ModalCartToggler);
  class ModalCartRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);

      this.applyColorScheme = (body) => {
        const { colorScheme } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      this.applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }

    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }

    close() {
      const parent = this.querySelector(this.dataset.selector);
      if (parent) parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }

    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }

    renderModal() {
      toggleLoader(true);
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          if (parent && html) parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
          toggleLoader(false);
        });
    }

    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }

    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      if (flag) {
        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('click', this.onBodyClick);
      } else {
        this.removeEventListener('keyup', this.onKeyUp);
        this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (!boundings || boundings.contains(target) || target === boundings) return;
      this.close();
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-cart-render-component'))
    customElements.define('modal-cart-render-component', ModalCartRenderComponent);
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' || event.target.parentElement.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]') || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }

    onLineItemUpdate() {
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const handleLineError = (parent, response) => {
    const parentElement = document.querySelector(parent);
    const errorContainer = parentElement.querySelector('[data-render-error]');
    errorContainer.classList.remove('hidden');
    errorContainer.innerText = response.errors;
    const qtyInput = parentElement.querySelector('input[name="updates[]"]');
    qtyInput.value = parseFloat(parentElement.dataset.initQty);
    toggleLoader(false);
    return (this.erorr = true);
  };
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  const lineItemUpdate = (line, quantity, sections, parent, id = null, itemKey = null) => {
    toggleLoader(true);
    const secArr = JSON.parse(sections);
    let url = routes.cart_change_url;
    let bodyObj = {
      sections: secArr.map((section) => section.id),
      sections_url: window.location.pathname,
    };

    if (id && itemKey) {
      url = routes.cart_update_url;
      bodyObj.updates = {
        [itemKey]: 0,
        [id]: quantity
      };
    } else {
      bodyObj.line = line;
      bodyObj.quantity = quantity;
    }
    
    var body = JSON.stringify(bodyObj);
    this.erorr = false;
    fetch(`${url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if (response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (!this.erorr) {
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if (modal) {
            if (modal.classList.contains('modal--active')) {
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        toggleLoader(false);
      });
  };
  class CartItemEditVariant extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggles = Array.from(this.querySelectorAll('[data-dropdown-toggler]'));
      this.contents = Array.from(this.querySelectorAll('[data-dropdown-content]'));
      this.variantJson = JSON.parse(this.querySelector('[data-variant-json]').textContent);
      this.currentOptions = JSON.parse(this.dataset.currentOptions || '[]');

      this.toggles.forEach((toggle, index) => {
        toggle.addEventListener('click', () => {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            this.closeDropdown(index);
          } else {
            this.openDropdown(index);
          }
        });
      });

      this.contents.forEach((content, optionIndex) => {
        content.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleOptionChange(optionIndex, btn.dataset.optionValue);
          });
        });
      });
    }

    openDropdown(index) {
      // Close others
      this.toggles.forEach((_, i) => { if(i !== index) this.closeDropdown(i); });

      const toggle = this.toggles[index];
      const content = this.contents[index];
      
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('dropdown--open');
      this.doAnimate(content);
      
      trapFocus(content);
      this._onBodyClick = this._onBodyClick || this.onBodyClick.bind(this);
      this._onKeyUp = this._onKeyUp || this.onKeyUp.bind(this);
      
      document.body.addEventListener('click', this._onBodyClick);
      this.addEventListener('keyup', this._onKeyUp);
    }

    closeDropdown(index) {
      const toggle = this.toggles[index];
      const content = this.contents[index];
      if (!toggle) return;
      
      toggle.setAttribute('aria-expanded', 'false');
      content.classList.remove('dropdown--open');
      
      document.body.removeEventListener('click', this._onBodyClick);
      this.removeEventListener('keyup', this._onKeyUp);
    }

    onBodyClick(event) {
      if (this.contains(event.target)) return;
      this.toggles.forEach((_, i) => this.closeDropdown(i));
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.toggles.forEach((_, i) => this.closeDropdown(i));
      }
    }

    doAnimate(element) {
      try {
        const frames = JSON.parse(element.dataset.frames);
        const options = JSON.parse(element.dataset.options);
        if (frames && options) element.animate(frames, options);
      } catch(e) {}
    }

    handleOptionChange(optionIndex, value) {
      this.toggles.forEach((_, i) => this.closeDropdown(i));
      
      const newOptions = [...this.currentOptions];
      newOptions[optionIndex] = value;
      
      const matchingVariant = this.variantJson.find(v => {
        return v.options.every((opt, i) => opt === newOptions[i]);
      });

      if (matchingVariant && matchingVariant.id !== parseInt(this.dataset.variantId)) {
        this.updateVariant(matchingVariant.id);
      } else if (!matchingVariant) {
        console.warn('No matching variant found for options:', newOptions);
      }
    }

    updateVariant(variantId) {
      lineItemUpdate(
        this.dataset.lineId, 
        this.dataset.quantity, 
        this.dataset.sections, 
        this.dataset.parentSelector,
        variantId,
        this.dataset.itemKey
      );
    }
  }
  if (!customElements.get('cart-item-edit-variant')) {
    customElements.define('cart-item-edit-variant', CartItemEditVariant);
  }
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-cart-totals'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'data-cart-totals' && oldValue !== newValue) {
            this.update();
          }
        }

        connectedCallback() {
          this.update();
        }

        update() {
          const rateFactor = Shopify.currency.rate || 1;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
          const epsilon = 0.001;

          // Milestones configuration
          const milestones = [
            {
              id: 'shipping',
              threshold: parseFloat(this.dataset.amount) * rateFactor,
              successText: this.dataset.freeShippingUnlockedText || 'Free shipping unlocked!',
              label: 'Free Shipping'
            }
          ];

          if (this.hasAttribute('data-discount-amount')) {
            milestones.push({
              id: 'discount',
              threshold: parseFloat(this.dataset.discountAmount) * rateFactor,
              successText: this.dataset.discountUnlockedText || 'Discount activated!',
              label: this.dataset.discountText || 'Discount'
            });
          }

          // Sort milestones by threshold to handle any user order
          milestones.sort((a, b) => a.threshold - b.threshold);

          const achieved = milestones.filter(m => cartTotals >= m.threshold - epsilon);
          const next = milestones.find(m => cartTotals < m.threshold - epsilon);

          const textContainer = this.querySelector('.shipping-bar_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }

            let message = '';
            if (achieved.length > 0) {
              message = achieved.map(m => m.successText).join(' & ');
            }

            if (next) {
              const remaining = next.threshold - cartTotals;
              const nextMessage = next.id === 'shipping' 
                ? this.baseTextTemplate.replace(/\|\|amount\|\|/g, `<span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span>`)
                : `Add <span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span> more for <span>${next.label}</span>`;
              
              message = message ? `${message} ${nextMessage}` : nextMessage;
            }

            textContainer.innerHTML = message || window.cartStrings.shippingAmount;
          }

          // Update Progress Bar Appearance
          const maxThreshold = milestones.length > 0 ? Math.max(...milestones.map(m => m.threshold)) : 100;
          const value = Math.min((cartTotals / maxThreshold) * 100, 100);
          
          const fill = this.querySelector('.milestone-fill');
          if (fill) {
            fill.style.width = value.toFixed(2) + '%';
            if (value >= 100 - epsilon) {
              fill.classList.add('is-full');
            } else {
              fill.classList.remove('is-full');
            }
          }

          milestones.forEach(m => {
            const milestoneEl = this.querySelector(`.milestone-point--${m.id}`);
            if (milestoneEl) {
              const percent = Math.min((m.threshold / maxThreshold) * 100, 100);
              milestoneEl.style.left = percent + '%';
              if (cartTotals >= m.threshold - epsilon) {
                milestoneEl.classList.add('is-active');
              } else {
                milestoneEl.classList.remove('is-active');
              }
            }
          });
        }
      }
    );
  }
  class cartDiscountCode extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      const input = this.querySelector('input[name="discount_code"]');
      if (!button || !input) return;
      const onClick = (event) => {
        event.preventDefault();
        toggleLoader(true);
        const secArr = JSON.parse(this.dataset.sections);
        const discountCode = input.value.trim();
        var body = JSON.stringify({
          discount: discountCode,
          sections: secArr.map((section) => section.id),
          sections_url: window.location.pathname,
        });
        this.erorr = false;
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const response = JSON.parse(responseText);
            if (response.errors) return handleLineError(parent, response);
            sectionArrRender(secArr, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.erorr) {
              const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
              if (modal) {
                if (modal.classList.contains('modal--active')) {
                  trapFocus(modal.content);
                  modal.setListeners(true);
                }
              }
            }
            toggleLoader(false);
          });
      };
      this.onClick = onClick;
      button.addEventListener('click', onClick);
    }
  }
  if (!customElements.get('cart-discount-code')) customElements.define('cart-discount-code', cartDiscountCode);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const btnToForgot = document.getElementById('toForgot');
  const btnToLogin = document.getElementById('toLogin');
  if (!btnToForgot || !btnToLogin) return;
  const loginWrapper = document.getElementById('login-wrapper');
  const forgetWrapper = document.getElementById('forget-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper) {
    const input = wrapper.querySelector('input[type="email"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToForgot.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToLogin.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const successElement = document.getElementById('RecoverForm-EmailSuccess');
    if (window.location.hash === '#recover' || successElement) {
      switchToRecover();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const btnToAccess = document.getElementById('toAccess');
  const btnToDefault = document.getElementById('toDefault');
  if (!btnToAccess || !btnToDefault) return;
  const loginWrapper = document.getElementById('direct-wrapper');
  const forgetWrapper = document.getElementById('access-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper, pass) {
    const input = wrapper.querySelector('input[type="email"]') || wrapper.querySelector('input[type="password"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToAccess.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToDefault.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const errorElement = document.getElementById('EnterForm-password-error');
    if (errorElement) switchToRecover();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-products-grid"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr, root = document) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      const element = root.querySelector(selector);
      if (element) arr.push(element);
    });
    return arr;
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal() {
      toggleLoader(true);
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
          toggleLoader(false);
        });
    }
    initFilters() {
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;

      const priceFacet = target.closest('.price-facet');
      if (priceFacet && priceFacet.getAttribute('data-invalid') === 'true') {
        return;
      }

      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
        case 'range':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-filter-component'))
    customElements.define('modal-filter-component', ModalFilterComponent);
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const openFacetKeys = this.getOpenFacetKeys();
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target, openFacetKeys);
        return;
      }
      this.renderFetch(url, true, searchParams, target, openFacetKeys);
    }

    getOpenFacetKeys() {
      const openFacetKeys = [];
      const details = document.querySelectorAll(
        'modal-filter-component.modal--active [data-render-facets] details[open][data-facet-key]'
      );
      details.forEach((item) => {
        if (item.dataset.facetKey) openFacetKeys.push(item.dataset.facetKey);
      });
      return openFacetKeys;
    }

    restoreOpenFacetKeys(openFacetKeys = []) {
      if (!openFacetKeys.length) return;
      openFacetKeys.forEach((key) => {
        const facet = document.querySelector(
          `modal-filter-component.modal--active [data-render-facets] details[data-facet-key="${CSS.escape(key)}"]`
        );
        if (facet) facet.setAttribute('open', '');
      });
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null, openFacetKeys = []) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if (modal) modal.initFilters();
          this.restoreOpenFacetKeys(openFacetKeys);
          if (target) {
            const org = document.getElementById(target);
            if (org) org.focus();
          }
          toggleLoader(false);
        });
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null, openFacetKeys = []) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if (modal) modal.initFilters();
      this.restoreOpenFacetKeys(openFacetKeys);
      if (target) {
        const org = document.getElementById(target);
        if (org) org.focus();
      }
      toggleLoader(false);
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content?.querySelectorAll('[data-btn-sort]');

      if (!this.button || !this.content) return;

      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;

      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };

      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };

      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.closeDropdown();
      };

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      };

      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };

      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };

      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.addEventListener('click', onSortSelect);
          });
        }
      };

      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.removeEventListener('click', onSortSelect);
          });
        }
      };

      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  if (!customElements.get('atc-submit') && typeof AtcSubmit !== 'undefined') {
    customElements.define('atc-submit', AtcSubmit);
  }
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled');
            if (this.loader) this.loader.classList.remove('hidden');
            if (typeof toggleLoader === 'function') toggleLoader(true);
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled');
                  if (this.loader) this.loader.classList.add('hidden');
                }

                if (typeof toggleLoader === 'function') toggleLoader(false);
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all');
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      };
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);
  class PriceRange extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.inputs = this.querySelectorAll('input[type="range"]');
      if(!this.inputs) return;

      this.parent = this.closest('.price-facet');
      this.numInputs = this.parent ? this.parent.querySelectorAll('input[type="number"]') : [];

      const onSlideWatch = (source = 'range') => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const errorElement = this.parent.querySelector('.price-range_error');
        
        if (source === 'range') {
          if (minInput && minVal > maxVal) {
            minInput.value = maxVal;
          }
          if (maxInput && maxVal < minVal) {
            maxInput.value = minVal;
          }
        }

        const currentMin = parseFloat(minInput.value);
        const currentMax = parseFloat(maxInput.value);

        if (currentMin > currentMax) {
          if (errorElement) errorElement.classList.remove('hidden');
          this.parent.setAttribute('data-invalid', 'true');
        } else {
          if (errorElement) errorElement.classList.add('hidden');
          this.parent.removeAttribute('data-invalid');
        }

        // Sync with number inputs
        if (this.numInputs.length > 0) {
          const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
          const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
          if (minNum) minNum.value = minInput.value;
          if (maxNum) maxNum.value = maxInput.value;
        }
      }

      const onNumWatch = (event) => {
        const target = event.target;
        const rangeInput = Array.from(this.inputs).find(i => i.name === target.name);
        if (rangeInput && target.value !== '' && !isNaN(parseFloat(target.value))) {
          rangeInput.value = target.value;
          onSlideWatch('number');
        }
      }

      const onNumChange = (event) => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        if (minVal > maxVal) {
          // Swap values
          const temp = minInput.value;
          minInput.value = maxInput.value;
          maxInput.value = temp;
          
          // Update number inputs
          if (this.numInputs.length > 0) {
            const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
            const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
            if (minNum) minNum.value = minInput.value;
            if (maxNum) maxNum.value = maxInput.value;
          }
          
          onSlideWatch('range'); // Trigger sync and clear error
          
          // Trigger form submission after swap
          const facetsFilter = document.querySelector('facets-filter');
          if (facetsFilter) facetsFilter.onSubmitHandler();
        }
      }

      this.watch = onSlideWatch.bind(this);
      this.numWatch = onNumWatch.bind(this);
      this.numChange = onNumChange.bind(this);

      this.inputs.forEach(input => {
        input.addEventListener('input', this.watch);
      });

      if (this.numInputs.length > 0) {
        this.numInputs.forEach(input => {
          input.addEventListener('input', this.numWatch);
          input.addEventListener('change', this.numChange);
        });
      }
    }
  }
  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  const getJsonParse = (attrStr, root = document) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      const element = root.querySelector(selector);
      if (element) arr.push(element);
    });
    return arr;
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal() {
      toggleLoader(true);
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
          toggleLoader(false);
        });
    }
    initFilters() {
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;

      const priceFacet = target.closest('.price-facet');
      if (priceFacet && priceFacet.getAttribute('data-invalid') === 'true') {
        return;
      }

      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
        case 'range':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-filter-component'))
    customElements.define('modal-filter-component', ModalFilterComponent);
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if (modal) modal.initFilters();
          if (target) {
            const org = document.getElementById(target);
            if (org) org.focus();
          }
          toggleLoader(false);
        });
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if (modal) modal.initFilters();
      if (target) {
        const org = document.getElementById(target);
        if (org) org.focus();
      }
      toggleLoader(false);
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content?.querySelectorAll('[data-btn-sort]');

      if (!this.button || !this.content) return;

      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;

      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };

      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };

      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.closeDropdown();
      };

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      };

      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };

      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };

      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.addEventListener('click', onSortSelect);
          });
        }
      };

      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.removeEventListener('click', onSortSelect);
          });
        }
      };

      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  if (!customElements.get('atc-submit') && typeof AtcSubmit !== 'undefined') {
    customElements.define('atc-submit', AtcSubmit);
  }
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled');
            if (this.loader) this.loader.classList.remove('hidden');
            if (typeof toggleLoader === 'function') toggleLoader(true);
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled');
                  if (this.loader) this.loader.classList.add('hidden');
                }

                if (typeof toggleLoader === 'function') toggleLoader(false);
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all');
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      };
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);
  class PriceRange extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.inputs = this.querySelectorAll('input[type="range"]');
      if(!this.inputs) return;

      this.parent = this.closest('.price-facet');
      this.numInputs = this.parent ? this.parent.querySelectorAll('input[type="number"]') : [];

      const onSlideWatch = (source = 'range') => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const errorElement = this.parent.querySelector('.price-range_error');
        
        if (source === 'range') {
          if (minInput && minVal > maxVal) {
            minInput.value = maxVal;
          }
          if (maxInput && maxVal < minVal) {
            maxInput.value = minVal;
          }
        }

        const currentMin = parseFloat(minInput.value);
        const currentMax = parseFloat(maxInput.value);

        if (currentMin > currentMax) {
          if (errorElement) errorElement.classList.remove('hidden');
          this.parent.setAttribute('data-invalid', 'true');
        } else {
          if (errorElement) errorElement.classList.add('hidden');
          this.parent.removeAttribute('data-invalid');
        }

        // Sync with number inputs
        if (this.numInputs.length > 0) {
          const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
          const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
          if (minNum) minNum.value = minInput.value;
          if (maxNum) maxNum.value = maxInput.value;
        }
      }

      const onNumWatch = (event) => {
        const target = event.target;
        const rangeInput = Array.from(this.inputs).find(i => i.name === target.name);
        if (rangeInput && target.value !== '' && !isNaN(parseFloat(target.value))) {
          rangeInput.value = target.value;
          onSlideWatch('number');
        }
      }

      const onNumChange = (event) => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        if (minVal > maxVal) {
          // Swap values
          const temp = minInput.value;
          minInput.value = maxInput.value;
          maxInput.value = temp;
          
          // Update number inputs
          if (this.numInputs.length > 0) {
            const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
            const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
            if (minNum) minNum.value = minInput.value;
            if (maxNum) maxNum.value = maxInput.value;
          }
          
          onSlideWatch('range'); // Trigger sync and clear error
          
          // Trigger form submission after swap
          const facetsFilter = document.querySelector('facets-filter');
          if (facetsFilter) facetsFilter.onSubmitHandler();
        }
      }

      this.watch = onSlideWatch.bind(this);
      this.numWatch = onNumWatch.bind(this);
      this.numChange = onNumChange.bind(this);

      this.inputs.forEach(input => {
        input.addEventListener('input', this.watch);
      });

      if (this.numInputs.length > 0) {
        this.numInputs.forEach(input => {
          input.addEventListener('input', this.numWatch);
          input.addEventListener('change', this.numChange);
        });
      }
    }
  }
  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-collapsibles"] && !Shopify.designMode) return;
  try {
    
  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleToggle = (event) => {
        const currentDetails = event.currentTarget.closest('details');
        
        if (!currentDetails.hasAttribute('open')) {
          const allDetails = this.querySelectorAll('details');
          allDetails.forEach((details) => {
            if (details !== currentDetails && details.hasAttribute('open')) {
              details.removeAttribute('open');
            }
          });
        }
      };
      this._handleToggle = handleToggle;
      this._details = this.querySelectorAll('details');
      this._details.forEach((details) => {
        const summary = details.querySelector('summary');
        if (summary) summary.addEventListener('click', this._handleToggle);
      });
    }
    disconnectedCallback() {
      if (this._details && this._handleToggle) {
        this._details.forEach((details) => {
          const summary = details.querySelector('summary');
          if (summary) summary.removeEventListener('click', this._handleToggle);
        });
      }
    }
  }

  if (!customElements.get('accordion-component')) customElements.define('accordion-component', AccordionComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  // tabset
  if (!customElements.get('tabset-component')) {
    customElements.define('tabset-component', class TabsetComponent extends HTMLElement {
      constructor() {
        super();
        
        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
        this.initialize();
        if(this.dataset.editorMode === 'true'){
          document.addEventListener('shopify:block:select', function (event) {
            const target = event.target;
            const parent = target.parentElement;
            if(parent.nodeName !== 'TABSET-COMPONENT') return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
      }
      
      initialize(){
        this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach(tab => {
          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));
        });
        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        let defaultTab = this.firstTab;
        if (this.dataset.hasPredictive === 'true') {
          const predictiveTab = this.tabs.find(tab => tab.dataset.activeTab === 'true');
          if (predictiveTab) defaultTab = predictiveTab;
        }
        this.setSelectedTab(defaultTab, false);
      }
    
      setSelectedTab(currentTab, setFocus = true) {
        this.tabs.forEach((tab, index) => {
          const panel = this.tabpanels[index];
          if (!panel) return;
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
          panel.classList.toggle('hidden', !isSelected);
          if (isSelected && setFocus) {
            tab.focus({ preventScroll: true });
          }
        });

        if (currentTab && currentTab.parentElement) {
          const navbar = currentTab.parentElement;
          const tabRect = currentTab.getBoundingClientRect();
          const navRect = navbar.getBoundingClientRect();
          const scrollLeft = navbar.scrollLeft + (tabRect.left - navRect.left) - (navRect.width / 2) + (tabRect.width / 2);
          navbar.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
      }
    
      setSelectedToPreviousTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      }
    
      setSelectedToNextTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
      }
    
      onKeydown(event) {
        const tgt = event.currentTarget;
        let flag = false;
    
        switch (event.key) {
          case 'ArrowLeft':
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;
    
          case 'ArrowRight':
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;
    
          case 'Home':
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;
    
          case 'End':
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;
    
          default:
            break;
        }
    
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    });
  }  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-badges"] && !Shopify.designMode) return;
  try {
    
  class SequentialAnimator extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-sequential-element]'));
      if (items.length === 0) return;
      let activeIndex = -1;
      let interval = null;
      const intervalTime = 2000;
      const setActive = (index) => {
        items.forEach(item => item.classList.remove('--active'));
        activeIndex = index;
        if (items[activeIndex]) items[activeIndex].classList.add('--active');
      };
      const next = () => {
        const nextIndex = (activeIndex + 1) % items.length;
        setActive(nextIndex);
      };
      const stopAnimation = () => {
        if (interval) clearInterval(interval);
      };
      const startAnimation = () => {
        stopAnimation();
        interval = setInterval(next, intervalTime);
      };
      startAnimation();
      this._animationActive = true;
      items.forEach((item, index) => {
        item.addEventListener('mouseenter', () => {
          stopAnimation();
          setActive(index);
        });
        item.addEventListener('mouseleave', () => {
          startAnimation();
        });
      });
      this._stopAnimation = stopAnimation;
    }
    disconnectedCallback() {
      if (this._stopAnimation) {
        this._stopAnimation();
        this._animationActive = false;
      }
    }
  }
  if (!customElements.get('sequential-animator')) customElements.define('sequential-animator', SequentialAnimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-insights"] && !Shopify.designMode) return;
  try {
    
  // tabset
  if (!customElements.get('tabset-component')) {
    customElements.define('tabset-component', class TabsetComponent extends HTMLElement {
      constructor() {
        super();
        
        this.tablistNode = this;
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
        this.initialize();
        if(this.dataset.editorMode === 'true'){
          document.addEventListener('shopify:block:select', function (event) {
            const target = event.target;
            const parent = target.parentElement;
            if(parent.nodeName !== 'TABSET-COMPONENT') return;
            parent.initialize();
            parent.setSelectedTab(target);
          });
        }
      }
      
      initialize(){
        this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach(tab => {
          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));
        });
        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        let defaultTab = this.firstTab;
        if (this.dataset.hasPredictive === 'true') {
          const predictiveTab = this.tabs.find(tab => tab.dataset.activeTab === 'true');
          if (predictiveTab) defaultTab = predictiveTab;
        }
        this.setSelectedTab(defaultTab, false);
      }
    
      setSelectedTab(currentTab, setFocus = true) {
        this.tabs.forEach((tab, index) => {
          const panel = this.tabpanels[index];
          if (!panel) return;
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
          panel.classList.toggle('hidden', !isSelected);
          if (isSelected && setFocus) {
            tab.focus({ preventScroll: true });
          }
        });

        if (currentTab && currentTab.parentElement) {
          const navbar = currentTab.parentElement;
          const tabRect = currentTab.getBoundingClientRect();
          const navRect = navbar.getBoundingClientRect();
          const scrollLeft = navbar.scrollLeft + (tabRect.left - navRect.left) - (navRect.width / 2) + (tabRect.width / 2);
          navbar.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
      }
    
      setSelectedToPreviousTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      }
    
      setSelectedToNextTab(currentTab) {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
      }
    
      onKeydown(event) {
        const tgt = event.currentTarget;
        let flag = false;
    
        switch (event.key) {
          case 'ArrowLeft':
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;
    
          case 'ArrowRight':
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;
    
          case 'Home':
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;
    
          case 'End':
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;
    
          default:
            break;
        }
    
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    });
  }  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations"]) return;
  try {
    
  const getJsonParse = (attrStr, root = document) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      const element = root.querySelector(selector);
      if (element) arr.push(element);
    });
    return arr;
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  // AtcSubmit class is now globally defined in product-shared.js
  if (!customElements.get('atc-submit') && typeof AtcSubmit !== 'undefined') {
    customElements.define('atc-submit', AtcSubmit);
  }
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled');
            if (this.loader) this.loader.classList.remove('hidden');
            if (typeof toggleLoader === 'function') toggleLoader(true);
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled');
                  if (this.loader) this.loader.classList.add('hidden');
                }

                if (typeof toggleLoader === 'function') toggleLoader(false);
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.empty = true;
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.empty = false;
                  this.innerHTML = recommendations.innerHTML;
                  if (!recommendations.innerHTML.includes('data-recommend-check')) {
                    let recommendationAncestor = this.parentElement;
                    while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                      recommendationAncestor = recommendationAncestor.parentElement;
                    }
                    if (recommendationAncestor) recommendationAncestor.classList.add('hidden');
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.empty) this.parentElement.classList.add('hidden');
              });
          };
          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator-popup"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first && !container.contains(event.target)) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalStoreComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    };
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
  }
  if(!customElements.get('modal-store-component')) customElements.define('modal-store-component', ModalStoreComponent);
  
  class StoreDropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(screen.width < 768) return;
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          const modal = this.closest('modal-store-component') || this.closest('.store-locations');
          const openDropdowns = modal
            ? [...modal.querySelectorAll('store-dropdown-component')].filter(
                d => d.button?.getAttribute('aria-expanded') === 'true'
              )
            : [];
          if (openDropdowns.length === 1 && openDropdowns[0] === this) {
            return;
          }
          return this.closeDropdown();
        }
        this.openDropdown();
      });
    }

    connectedCallback() {
      if(screen.width < 768) return;
      const self = this;
      const getModalDropdowns = () => {
        return self.closest('modal-store-component')?.querySelectorAll('store-dropdown-component') || self.closest('.store-locations')?.querySelectorAll('store-dropdown-component') || [];
      };
      const closeAllDropdowns = () => {
        const siblings = getModalDropdowns();
        siblings.forEach(dropdown => {
          if (dropdown !== self && dropdown.button?.getAttribute('aria-expanded') === 'true') {
            if (typeof dropdown.closeDropdown === 'function') {
              dropdown.closeDropdown({ force: true });
            } else {
              dropdown.button.setAttribute('aria-expanded', false);
              dropdown.content.classList.remove('dropdown--open', 'widget--styles');
              document.body.removeEventListener('click', dropdown._onBodyClick);
            }
          }
        });
      };
      const openDropdown = () => {
        closeAllDropdowns();
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open', 'widget--styles');
        self._onBodyClick = onBodyClick;
        document.body.addEventListener('click', onBodyClick);
      };
      const closeDropdown = (opts = {}) => {
        const force = Boolean(opts.force);
        if (!force) {
          const openDropdowns = [...getModalDropdowns()].filter(
            d => d.button?.getAttribute('aria-expanded') === 'true'
          );
          if (openDropdowns.length === 1 && openDropdowns[0] === self) return;
        }
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open', 'widget--styles');
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('store-dropdown-component')) { customElements.define('store-dropdown-component', StoreDropdownComponent); }

  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleToggle = (event) => {
        const currentDetails = event.currentTarget.closest('details');
        
        if (!currentDetails.hasAttribute('open')) {
          const allDetails = this.querySelectorAll('details');
          allDetails.forEach((details) => {
            if (details !== currentDetails && details.hasAttribute('open')) {
              details.removeAttribute('open');
            }
          });
        }
      };
      this._handleToggle = handleToggle;
      this._details = this.querySelectorAll('details');
      this._details.forEach((details) => {
        const summary = details.querySelector('summary');
        if (summary) summary.addEventListener('click', this._handleToggle);
      });
    }
    disconnectedCallback() {
      if (this._details && this._handleToggle) {
        this._details.forEach((details) => {
          const summary = details.querySelector('summary');
          if (summary) summary.removeEventListener('click', this._handleToggle);
        });
      }
    }
  }

  if (!customElements.get('accordion-component')) customElements.define('accordion-component', AccordionComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? direction === 'forward'
            ? 'marquee-vertical-forward'
            : 'marquee-vertical-reverse'
          : direction === 'forward'
          ? 'marquee-horizontal-forward'
          : 'marquee-horizontal-reverse';
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach((el) => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-grid"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }

    onClickRef() {
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        if (this.dataset.offset) {
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if (!offsetElement) {
            doScroll();
            if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }

      function doScroll() {
        targetElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();
})();
